"use client";

import { useState } from "react";

import { ErrorCard } from "#app/_ui/components/cards/ErrorCard";

import {
  ForgotPasswordIdle,
  type ForgotPasswordIdleProps,
} from "./ForgotPasswordIdle";
import { ForgotPasswordSuccess } from "./ForgotPasswordSuccess";

export default function ForgotPasswordPage() {
  const [status, setStatus] =
    useState<Parameters<ForgotPasswordIdleProps["onChangeStatus"]>[0]>("idle");

  return (
    <div className="m-auto grid w-full max-w-850px">
      {status === "error" ? (
        <ErrorCard />
      ) : status === "success" ? (
        <ForgotPasswordSuccess />
      ) : (
        <ForgotPasswordIdle onChangeStatus={setStatus} />
      )}
    </div>
  );
}
